// Components
import SubmitButtonMagenta from 'Components/SubmitButtonMagenta'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    SubmitButtonMagenta,
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    toggleLoadingStatus() {
      this.loading = !this.loading
    },
  },
}
